import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Row } from 'reactstrap';
import { GetQuestionsResponse, UserPermissions } from '../types'
import { copyTextToClipboard } from "../utils/copyToClipboard";
import Toastr from "toastr";
import { useCurrentUser } from '../hooks/useCurrentUser';
import { useStoreActions } from '../stores/store';
import Markdown from "markdown-to-jsx";

const SingleQuestion: React.FC<{
  question: GetQuestionsResponse[number];
}> = ({
  question,
}) => {
    const { data: user } = useCurrentUser()
    const [activeSource, setActiveSource] = useState(0);
    const [collapsed, setCollapsed] = useState(true);
    const [markdownContent, setMarkdownContent] = useState<string[]>([]);

    // console.log("question -- ", question);

     // Get the updateSearchTerm action from the store
    const updateSearchTerm = useStoreActions(s => s.updateSearchTerm); 

    const handleSourceClick = (phrase: string) => {
      updateSearchTerm(phrase); // Update the search term in the store
    };

    const handleCopyAllSources = () => {
      if (!question.qaResponse || !question.qaResponse.sources || !question.qaResponse.sources[activeSource]) return

      const sources = question.qaResponse.sources[activeSource]
      copyTextToClipboard(sources.map((source) => source.value).join("\n"))
      Toastr.success("Copied to clipboard")
    }

    const handleCopyAllOutput = () => {
      if (!question.qaResponse || !question.qaResponse.responses) return

      const responses = question.qaResponse.responses
      copyTextToClipboard(responses.join("\n"))
      Toastr.success("Copied to clipboard")
    }

    useEffect(() => {
      if (question.qaResponse && question.qaResponse.responses) {
        setMarkdownContent(question.qaResponse.responses);
      }
    }, [question.qaResponse]);

    return (
      <Container fluid className='mb-4'>
        <Card className="shadow">
          <CardHeader className="border-0">
            <h4 style={{ display: 'inline' }}>{question.question}</h4>
            <span className="float-right">
              <Button size="sm" color="primary" onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? 'Expand' : 'Collapse'}
              </Button>
            </span>
            <br />
            <span>
              Asked by: {question.user.name}
              {question.qaResponse?.cost && user?.roles.includes(UserPermissions.admin) && ` | Cost: $${question.qaResponse.cost.toFixed(4)}`}
            </span>
          </CardHeader>
          <Collapse isOpen={!collapsed}>
            <CardBody>
              <Row>
                <Col className="order-xl-1">
                  {/* <Row>
                  <Col
                    xs="6"
                    className="offset-3"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter the question here"
                      value={question.question}
                    />
                  </Col>
                </Row> */}
                  {
                    question?.qaResponse?.responses &&
                    question?.qaResponse?.responses?.length > 0 &&
                    <Row className="ques-resp-col">
                      <Col
                        xs="6"
                        className="ques-resp-col"
                        style={{
                          overflowY: "scroll",
                          maxHeight: "400px",
                        }}
                      >
                        <h2
                          className="row-h2"
                          style={{
                            position: "sticky",
                            top: "0",
                            background: "white",
                            textAlign: "center",
                          }}
                        >
                          Output&nbsp;
                          <small>
                            (
                            {(Array.isArray(question?.qaResponse?.responses) ? question?.qaResponse?.responses : []).reduce((acc, curr) => acc + curr).split(' ').filter(w => w.length > 0).length} words
                            )
                          </small>
                          {
                            question.qaResponse.responses &&
                            question.qaResponse.responses.length > 0 &&
                            <small className="ml-2">
                              <i
                                className="fas fa-copy"
                                onClick={handleCopyAllOutput}
                                style={{ cursor: 'pointer' }}
                              />
                            </small>
                          }
                        </h2>
                        <ul>
                        {markdownContent.length > 0 && (
                          <Row className="ques-resp-col">
                            {/* ... */}
                            {markdownContent.map((item, index) => (
                              <li
                                className="li-resp-col"
                                style={{ textDecoration: "none" }}
                                key={index}
                                onClick={() => {
                                  setActiveSource(index);
                                }}
                              >
                                <Markdown>{item}</Markdown>
                              </li>
                            ))}
                            {/* ... */}
                          </Row>
                        )}
                          {/* {question.qaResponse.responses
                            .length > 0 &&
                            question.qaResponse.responses.map(
                              (item, index) => {
                                const newText = item.replace(
                                  /\n+/g,
                                  "<br />"
                                );
                                return (
                                  <li
                                    className="li-resp-col"
                                    style={{
                                      textDecoration: "none",
                                    }}
                                    key={index}
                                    onClick={() => {
                                      setActiveSource(index);
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: newText,
                                    }}
                                  ></li>
                                );
                              }
                            )} */}
                        </ul>
                      </Col>
                      <Col
                        xs="6"
                        className="ques-resp-col"
                        style={{
                          overflowY: "scroll",
                          maxHeight: "400px",
                        }}
                      >
                        <h2
                          className="row-h2"
                          style={{
                            position: "sticky",
                            top: "0",
                            background: "white",
                            textAlign: "center",
                          }}
                        >
                          References&nbsp;
                          <small>
                            (
                            {(question.qaResponse.sources.length === 0 ? [[{ value: '' }]] : question.qaResponse.sources).flat().map(c => c.value).reduce((acc, curr) => acc + curr).split(' ').filter(w => w.length > 0).length} words
                            )
                          </small>
                          {
                            question.qaResponse.sources &&
                            question.qaResponse.sources.length > 0 &&
                            <small className="ml-2">
                              <i
                                className="fas fa-copy"
                                onClick={handleCopyAllSources}
                                style={{ cursor: 'pointer' }}
                              />
                            </small>
                          }
                        </h2>
                        <ul>
                          {question.qaResponse.sources[
                            activeSource
                          ] &&
                            question.qaResponse.sources[
                              activeSource
                            ].map((item, idx) => (
                              <li
                                style={{ cursor: "pointer" }}
                                className="li-source-col"
                                key={idx}
                                onClick={() => {
                                  handleSourceClick(item.value);
                                }}
                              >
                                {item.value}
                              </li>
                            ))}
                        </ul>
                      </Col>
                    </Row>
                  }
                </Col>
              </Row>
            </CardBody>
          </Collapse>
        </Card>
      </Container>
    )
  }

export default SingleQuestion